import type { SendInvitesToPeoByCvStaffMutationVariables } from 'src/api';

import type { InviteFormValues } from '../types';

export const convertFormValues = (
  formValues: InviteFormValues,
): SendInvitesToPeoByCvStaffMutationVariables => {
  const { peoPayrollProvider, peos } = formValues;
  const isPeoPpDefined = !!peoPayrollProvider;

  return {
    peoPayrollProviderId: peoPayrollProvider?.id,
    peos: peos.map(peo => {
      if (!isPeoPpDefined) return peo;
      return { ...peo, isRevenueShareEnabled: false };
    }),
  };
};
